/**
 * @file: react-native-user-agent.web.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

const factory = {
  getUserAgent() {
    return navigator.userAgent;
  },
};

export default factory;
